<transition name="appear"><slot></slot></transition>